<mat-icon *ngIf="isBusyCounter > 0 || isLoading" class="m-l-10">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</mat-icon>
